<template>
    <div class="container">
        <div class="navigation-wrapper">
            <div class="row">
                <div class="col-12">
                    <router-link to="/">
                        <img class="img img-logo" src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/logo-bell-buddy-rewards.png" alt="Bell Buddy Rewards Logo" />
                    </router-link>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-xs-12">
                <h2>404</h2>
                <p>Page not found</p>
                <p>
                    <router-link to="/" class="btn btn-primary btn-bellstores">Return Home</router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style scoped lang="scss">
    .btn {
        margin: 10px auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue